<script>
    import StarRating from 'vue-star-rating';
    import {Form} from '../../helpers/Form/Form'
    import {Gtag} from '../../mixins/ga'

    export default {
        mixins: [Gtag],
        components: {
            StarRating
        },
        props: {
            courseprop: Object,
            limitCharacters: {
                type: Number,
                default: 150
            }
        },
        data() {
            return {
                starSize: 13,
                course: null,
                form: new Form({
                    technical_preparation_score: 0,
                    inclusive_environment_score: 0,
                    cleanliness_score: 0,
                    equipment_score: 0,
                    total_score: 0.0.toFixed(1) * 1,
                    review_title: "",
                    review_text: "",
                    experience_type: "is_first_trial",
                    user_name: null,
                    user_surname: null,
                    user_email: null,
                }),
            }
        },
        mounted() {
            this.course = this.courseprop;

            let reviewModal = this.getParameterByName('open')
            if (!_.isEmpty(reviewModal)) {
                $("#reviewModal").modal('show')
            }

            $("#reviewThanksModal").modal({
                backdrop: 'static',
                keyboard: false,
                show: false
            }).on('hidden.bs.modal', () => {
                this.form.reset()
            })
            $("#reviewUserModal").modal({
                backdrop: 'static',
                keyboard: false,
                show: false
            }).on('hidden.bs.modal', () => {
                this.form.reset()
            })

            window.addEventListener('resize', () => {
                this.initStarSize()
            });            
            this.initStarSize()
        },
        computed: {
            charactersLeft() {
                let limit = this.limitCharacters - this.form.review_text.length;
                return `${limit}/${this.limitCharacters} caratteri rimanenti`
            },
            totalScoreLabel() {
                return this.form.total_score.toFixed(1)
            }
        },
        methods: {
            initStarSize() {
                let starSize = 13
                if (window.isMobile()) {
                    starSize = 30
                }

                this.$set(this, 'starSize', starSize)
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');

                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return '';

                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            checkLimit(evt) {
                if (this.form.review_text.length >= this.limitCharacters) {
                    if (evt.keyCode >= 48 && evt.keyCode <= 90) {
                        evt.preventDefault()
                        return
                    }
                }
            },
            createReview() {
                var self = this;
                this.form
                    .submit('post', `/course/${this.course.id}/review`)
                    .then(({review}) => {
                        this.$set(this.form, 'review', Object.assign(this.form, {
                            id: review.id,
                            experience_type: review.experience_type
                        }));

                        if (window.isMobile()) {
                            this.sendGaEvent(
                                'Recensione',
                                'Corsi',
                                '#scrivi-recensione-invia-mobile'
                            )
                        } else {
                            this.sendGaEvent(
                                'Recensione',
                                'Corsi',
                                '#scrivi-recensione-invia'
                            )
                        }

                        $('#reviewModal').modal('hide');
                        $('#reviewUserModal').modal('show');
                    })
            },
            verifyReview() {
                var self = this;
                this.form
                    .submit('post', `/review/${this.form.id}/verify`)
                    .then(response => {
                        if (response.status == "verified") {
                            $('#course-already-reviewed-error').hide();
                            $('#reviewUserModal').modal('hide');
                            $('#reviewThanksModal').modal('show');
                        }
                        else if (response.status == "already_reviewed") {
                            $('#course-already-reviewed-error').show();
                        } else {
                            $('#course-already-reviewed-error').hide()
                            $('#empty-email-error').show();
                            $('#reviewUserModal').modal('hide');
                            $('#reviewThanksModal').modal('show');
                        }
                    })
            }

        },

        watch: {
            form: {
                handler() {
                    this.form.total_score = ((parseInt(this.form.technical_preparation_score) + parseInt(this.form.inclusive_environment_score) + parseInt(this.form.cleanliness_score) + parseInt(this.form.equipment_score)) / 4);
                },
                deep: true,
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseStarRating.vue